import React from 'react';
import { Typography, Box, FormControl, Select, MenuItem } from '@mui/material';
import Flex from 'ui/Flex/Flex';
import { HrSimulationOfficialGrade } from '../helpers/types';
import { StyLoadingSkeleton, StyBlock } from './StyledComponents';
import { useTranslation } from 'react-i18next';

const EchelonSelect = ({
    isLoading,
    echelon,
    onEchelonChange,
    onSalaryChange,
    onChanges,
    gradeData,
    echelonKeys,
    isUpdateEnabled,
}: {
    onChanges: (hasGradeChanges: boolean) => void;
    echelon: string;
    onEchelonChange: (echelon: string) => void;
    isLoading: boolean;
    onSalaryChange: (gradeSalary: number) => void;
    gradeData: HrSimulationOfficialGrade | undefined;
    echelonKeys: string[];
    isUpdateEnabled: boolean;
}): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <StyBlock>
            <Typography variant="h5" color="primary">
                {t('humanResources.simulation.gradeHypothesis.echelon')}
            </Typography>
            <Flex flexDirection="row" gap="10px">
                <Box width="50%">
                    <Typography variant="body1">
                        {t(
                            'humanResources.simulation.gradeHypothesis.newEchelon',
                        )}
                    </Typography>
                    {isLoading ? (
                        <StyLoadingSkeleton />
                    ) : (
                        <FormControl fullWidth>
                            <Select
                                disabled={!isUpdateEnabled}
                                value={echelon}
                                onChange={(e) => {
                                    const newEchelon = e.target.value;
                                    onEchelonChange(newEchelon);
                                    const newSalary =
                                        gradeData?.gridEchelons[newEchelon]
                                            ?.rawSalary;
                                    if (newSalary) onSalaryChange(newSalary);
                                    onChanges(true);
                                }}
                                size="small"
                                sx={{
                                    backgroundColor: 'white',
                                    marginTop: '5px',
                                }}
                            >
                                {!gradeData && (
                                    <MenuItem value="" disabled>
                                        {t('common.noResult')}
                                    </MenuItem>
                                )}
                                {(() => {
                                    const sortedEchelonKeys = echelonKeys.sort(
                                        (a, b) => parseFloat(a) - parseFloat(b),
                                    );
                                    return sortedEchelonKeys.map((key) => (
                                        <MenuItem value={key} key={key}>
                                            {key}
                                        </MenuItem>
                                    ));
                                })()}
                            </Select>
                        </FormControl>
                    )}
                </Box>
            </Flex>
        </StyBlock>
    );
};

export default EchelonSelect;
